"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _isString = _interopRequireDefault(require("./isString.js"));
var _isArguments = _interopRequireDefault(require("./isArguments.js"));
var _keys = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Is a given array, string, or object empty?
// An "empty" object has no enumerable own-properties.
function isEmpty(obj) {
  if (obj == null) return true;
  // Skip the more expensive `toString`-based type checks if `obj` has no
  // `.length`.
  var length = (0, _getLength.default)(obj);
  if (typeof length == 'number' && ((0, _isArray.default)(obj) || (0, _isString.default)(obj) || (0, _isArguments.default)(obj))) return length === 0;
  return (0, _getLength.default)((0, _keys.default)(obj)) === 0;
}